import Vue from 'vue'
import _ from 'lodash'
import dateFormat from 'vux/src/tools/date/format.js'
import ChinaAddressData from 'vux/src/datas/china_address.json'



Vue.filter('addressList', function(res, addr) {
if (res) {
res = res.substr(0, res.indexOf(':'))
return res + " " + addr;
} else {
return "";
}
});


Vue.filter('timerForm', (res, t = 'YYYY-MM-DD HH:mm:ss') => {
return dateFormat(new Date(res * 1000), t)
});

Vue.filter('date', (res, t = 'YYYY-MM-DD') => {
var date = new Date(res)
if (date) {
return dateFormat(date, t)
} else {
return ''
}
});

Vue.filter('dateToString', (res, t = 'YYYY-MM-DD HH:mm:ss') => {
var date = new Date(res)
if (date) {
return dateFormat(date, t)
} else {
return ''
}
});


Vue.filter('priceFilter', function(price) {
return price ? Number(price).toFixed(2) : 0;
});


Vue.filter('fen2yuan', function(price) {
return price ? (Number(price) / 100).toFixed(2) : 0;
});


Vue.filter('paymentMethod', function(key) {
var paymentMethods = {
wxpay: '微信支付',
alipay: '支付宝付款'
}
var paymentMethod = paymentMethods[key];
return paymentMethod ? paymentMethod: '';
});

Vue.filter('orderStatus', function(key) {
var orderStatues = {
unpaid: '待付款',
paid: '待发货',
shipped: '已发货',
received: '已完成',
cancelled: '已取消',
refund: '申请退款中',
refunding: '退款中',
refunded: '已退款'
}
var orderStatus = orderStatues[key];
return orderStatus ? orderStatus: '';
});


Vue.filter('fommaterAddress', (area) => {
let areaNameArray = []
_.forEach(area, (item) => {
areaNameArray.push(_.find(ChinaAddressData, {value: item + ''}).name)
})
return areaNameArray.join('/')
});


Vue.filter('ke', (g) => {
if (g >= 1000) {
return (g / 1000) + 'kg'
} else {
return g + 'g'
}
});



// WEBPACK FOOTER //
// ./src/filters/index.js